import { fetchBuildersList as fetchBuildersListService } from '../../services/fetchBuildersList';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState } from '../../types/redux';
import { Dispatch } from '../../types/redux/app_state';
import { trackPageView } from '../../utils/analytics';
import { IThunkActionCreator } from '../../utils/redux';

export const fetchBuildersList = (limit: number, page: number, regionId: number | undefined): IThunkActionCreator => {
  return async function (dispatch: Dispatch, _getState: () => IApplicationState, context: IApplicationContext) {
    const buildersList = await fetchBuildersListService(context, {
      limit,
      page,
      regionId,
    });
    dispatch({
      type: 'IBuildersListFetched',
      buildersList,
    });

    const { abGroup } = _getState();

    const { deviceType, userId } = context.custom;

    trackPageView({ buildersList, abGroup, deviceType, userId });
  };
};
